import { JobScopeChangeStatus as JobScopeChangeStatusProto } from '@taxfyle/api-internal/internal/job_scope_change_pb'

export type JobScopeChangeStatus =
  | 'Accepted'
  | 'Rejected'
  | 'PendingFinalization'
  | 'PendingAdminApproval'
  | 'PendingClientApproval'
  | 'ApplyFailed'
  | 'Unspecified'

export enum JobScopeChangeRequestStatus {
  PENDING_FINALIZATION,
  PENDING_ADMIN_APPROVAL,
  PENDING_CLIENT_APPROVAL,
  ACCEPTED,
  REJECTED,
  UNSPECIFIED,
  APPLY_FAILED,
}

/**
 * Job Scope change.
 */
export interface JobScopeChangeRequestDTO {
  id: string
  job_id: string
  reason: string
  rejectionReason: string
  status: JobScopeChangeStatus
  items: JobScopeChangeItemDTO[]
  created_by_user_public_id: string
  create_time: Date
  latest_response_time?: Date
  workspace_id: string
}

/**
 * Job scope change item.
 */
export interface JobScopeChangeItemDTO {
  id: string
  name: string
  quantity: number
}

export function mapProtoToJobScopeChangeStatusDto(
  status: JobScopeChangeStatusProto,
): JobScopeChangeStatus {
  switch (status) {
    case JobScopeChangeStatusProto.ACCEPTED:
      return 'Accepted'
    case JobScopeChangeStatusProto.PENDING_ADMIN_APPROVAL:
      return 'PendingAdminApproval'
    case JobScopeChangeStatusProto.PENDING_CLIENT_APPROVAL:
      return 'PendingClientApproval'
    case JobScopeChangeStatusProto.REJECTED:
      return 'Rejected'
    case JobScopeChangeStatusProto.PENDING_FINALIZATION:
      return 'PendingFinalization'
    case JobScopeChangeStatusProto.APPLY_FAILED:
      return 'ApplyFailed'
    case JobScopeChangeStatusProto.UNSPECIFIED:
      return 'Unspecified'
  }
}
